import React from 'react';
import { eventType } from "../../../../../../util/varibles/constants";
import { checkLimit } from "../../../../../../util/varibles/global";
import { IOperation } from "../../../../../../util/varibles/interface";
import styles from "./style.module.scss";

const Event: React.FC<IOperation> = ({ vessel, operation }) => {
    const { event_type, note = '', vessel_name = "" } = operation;
    const { name = vessel_name } = vessel || {};
    const { name: eventName = '' } = eventType[event_type] || {};
    const voyage = [name, `${eventName}${note.length > 0 ? (': ' + note) : ''} `].join(' | ');
    const style: any = { '--width-indent': -(checkLimit(0, undefined, voyage.length - 58) * 7) + 'px' };

    return <>
        <div className={styles['line-info']}>
            <div className='animation-ellipsis'>
                <div className='animation-ellipsis-text flex text-nowrap' style={style}>
                    {voyage}
                </div>
            </div>
        </div>
    </>;
}

export default Event;
